import React,{ useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import useAnimateOnScroll from "../hooks/useAnimateOnScroll.js";

const Home = () => {

  const navigate = useNavigate(); 

  const handleProjectsClick= () => { 
    navigate('/projects');
  };

  const handlePortfolioClick= () => { 
    navigate('/portfolio');
  };
  

  useAnimateOnScroll(); 

  return (
    <div id="home" class="container, view">
        <ul id="cards">
        <li class="card">
          <div class="card-body">
          <h1>Willkommen auf meiner persönlichen Website!</h1>
          <p>Diese Seite befindet sich aktuell noch im Aufbau, dennoch findest du hier bereits einige meiner Projekte und einen kleinen Einblick in mein Portfolio.
Schau dich gerne um, entdecke die ersten Inhalte und bleib gespannt auf das, was noch folgt :)</p>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Home;
